// !------------- Material UI Components and Icons -------------! 
// !--- MUI ---! 
import { createTheme } from '@mui/material/styles';
// Documentation: https://mui.com/material-ui/customization/theming/

/**
 * OverallTheme is a customized MUI theme that defines color palettes.
 * It provides consistent color schemes across the application.
 */
const OverallTheme = createTheme({
  typography: {
    fontFamily: 'Montserrat, Arial, sans-serif',
    h1: {
      fontFamily: 'Russo One, Arial, sans-serif',
    },
    h2: {
      fontFamily: 'Russo One, Arial, sans-serif',
    },
    h3: {
      fontFamily: 'Russo One, Arial, sans-serif',
    },
    h4: {
      fontFamily: 'Russo One, Arial, sans-serif',
    },
    h5: {
      fontFamily: 'Russo One, Arial, sans-serif',
    },
    h6: {
      fontFamily: 'Russo One, Arial, sans-serif',
    },
    subtitle1: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 500,
    },
    subtitle2: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 500,
    },
    body1: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 500,
    },
    body2: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 500,
    },
    button: {
      fontFamily: 'Montserrat, Arial, sans-serif',
      fontWeight: 500,
    },
    caption: {
      fontFamily: 'Montserrat, Arial, sans-serif',
    },
    overline: {
      fontFamily: 'Montserrat, Arial, sans-serif',
    },
  },
  palette: {
    // Palette for Realtor 
    Realtor: {
      primary: {
        main: '#000',
        white: '#BC2076',
        black: '#000',
        teal: '#0640FC',
      },
      secondary: {
        lightGrey: '#B4BBC4',
        darkGrey: '#FFC0E6',
        darkTeal: '#EFBC1B',
        gold: '#CED8F2',
        orange: '#08F9B4',
        darkGold: '#D6D9DE',
        mediumTeal: '#EFF2F4',
        burntOrange: '#5DB59A',
        darkPuple: '#330D91',
        darkBlue: '#120A54',
        main: '#000',   
      },
    },
    // Palette for Commercial 
    Commercial: {
      primary: {
        commercialRed: "#CF1F28",
        mahogany:"#52121E",
        apricot:"##FF7F61",
        cardinal:"#8F050A"
      },
      secondary: {
        canary: "#F5E566",
        apricot: "#FF7F61",
        code: "#6EC49B",
        teal:"#007A8A"     
      },
    },
    // Palette for Advocacy 
    Advocacy: {
      primary: {
        advocacyPurple:"#41134A",
        lilac:"#B03995",
        apricot:"##FF7F61",
        lavender:"#BB3DD4"
      },
      secondary: {
        canary: "#F5E566",
        apricot: "#FF7F61",
        code: "#6EC49B",
        teal:"#007A8A"     
      },
    },
    // Palette for REAL 
    REAL: {
      primary: {
        white: '#BC2076',
        lightGrey: '#B4BBC4',
        darkPuple: '#330D91',
        darkGrey: '#FFC0E6',
        darkTeal: '#EFBC1B',
        gold: '#CED8F2',
        orange: '#08F9B4',
        darkGold: '#D6D9DE',
        burntOrange: '#5DB59A',
        teal: '#0640FC',
      },
      secondary: {
        white: '#BC2076',
        burntOrange: '#5DB59A',
        lightGrey: '#B4BBC4',
        darkGrey: '#FFC0E6',
        gold: '#CED8F2',
        orange: '#08F9B4',
        darkGold: '#D6D9DE',
        darkPuple: '#330D91',
        darkBlue: '#120A54',
      },
    }
  },
});

export default OverallTheme;
